import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../shared/models/api-response.model';
import { HttpCommonService } from '../../../shared/services/http-common-service';
import { AgreementAttachmentDto, AgreementCancelReason, AgreementDashboardDto, AgreementDto, AgreementItemAddEditDto, AgreementItemDto, AgreementPaymentDto, AgreementPaymentAddEditDto, AgreementSaveDto, GenerateAgreementDto, SearchAgreementDto } from '../models/agreement-models';
import { SelectList } from '../../../shared/models/select-list';


@Injectable({
  providedIn: 'root'
})
export class AgreementService {
  baseUrl = 'Agreement';
  constructor(private httpCommonService: HttpCommonService) {
  }

  search(searchObjVM?: SearchAgreementDto): Observable<ApiResponse<SearchAgreementDto>> {
    return this.httpCommonService.post<ApiResponse<SearchAgreementDto>>({
      url: this.baseUrl + "/Search",
      body: searchObjVM
    });
  }

  getAgreementDashboard(): Observable<ApiResponse<AgreementDashboardDto>> {
    return this.httpCommonService.get<ApiResponse<AgreementDashboardDto>>({ url: this.baseUrl + "/GetAgreementDashboard" });
  }

  cancel(obj: AgreementCancelReason): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/Cancel', body: obj });
  }


  export(searchObjVM: SearchAgreementDto): Observable<Blob> {
    return this.httpCommonService.post({ url: this.baseUrl + "/Export", body: searchObjVM, responseType: 'blob' });
  }

  Save(obj: AgreementSaveDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/Save', body: obj });
  }

  addAgreementItem(obj: AgreementItemAddEditDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/AddAgreementItem', body: obj });
  }

  getById(id: string): Observable<ApiResponse<AgreementDto>> {
    return this.httpCommonService
      .get<ApiResponse<AgreementDto>>({ url: this.baseUrl + '/Get/' + id });
  }
  //changeActivationStatus(id: string): Observable<BaseApiResponse> {
  //  return this.httpCommonService
  //    .get<BaseApiResponse>({ url: this.baseUrl + '/ChangeActivationStatus/' + id });
  //}

  getAgreementItems(agreementId: string): Observable<ApiResponse<AgreementItemDto[]>> {
    return this.httpCommonService.get<ApiResponse<AgreementItemDto[]>>({ url: this.baseUrl + "/GetItemsById/" + agreementId });
  }

  getAgreementIdByRequest(id: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.get<ApiResponse<string>>({ url: this.baseUrl + "/GetAgreementIdByRequest/" + id });
  }


  addAttachment(file: File, fileName: string, agreementId: string): Observable<ApiResponse<string>> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);
    formData.append('agreementId', agreementId);

    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/AddAttachment', body: formData });
  }

  getAttachments(id: string): Observable<ApiResponse<AgreementAttachmentDto[]>> {
    return this.httpCommonService
      .get<ApiResponse<AgreementAttachmentDto[]>>({ url: this.baseUrl + '/GetAttachments/' + id });
  }


  deleteAttachments(id: string): Observable<ApiResponse<AgreementAttachmentDto[]>> {
    return this.httpCommonService
      .delete<ApiResponse<AgreementAttachmentDto[]>>({ url: this.baseUrl + '/Delete/' + id });
  }

  downloadFile(id: string): Observable<Blob> {
    return this.httpCommonService
      .get<Blob>({
        url: this.baseUrl + '/Download/' + id,
        responseType: 'blob'
      });
  }

  getSelectList(): Observable<ApiResponse<SelectList[]>> {
    return this.httpCommonService.get<ApiResponse<SelectList[]>>({
      url: this.baseUrl + '/GetSelectList'
    });
  }

  getAgreementPayments(agreementId: string): Observable<ApiResponse<AgreementPaymentDto[]>> {
    return this.httpCommonService.get<ApiResponse<AgreementPaymentDto[]>>({ url: this.baseUrl + "/GetPayments/" + agreementId });
  }

  addAgreementPayment(obj: AgreementPaymentAddEditDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/SavePayment', body: obj });
  }

  updateAgreementPayment(obj: AgreementPaymentAddEditDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.put<ApiResponse<string>>
      ({ url: this.baseUrl + '/SavePayment', body: obj });
  }

  deleteAgreementPayment(id: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.delete<ApiResponse<string>>
      ({ url: this.baseUrl + '/DeletePayment/' + id });
  }

  clone(id: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/Clone/' + id, body: {} });
  }

  getAgreementGenerationData(id: string): Observable<ApiResponse<GenerateAgreementDto>> {
    return this.httpCommonService.get<ApiResponse<GenerateAgreementDto>>({ url: this.baseUrl + "/GetAgreementGenerationData/" + id });
  }

  generateAgreement(dto: GenerateAgreementDto): Observable<ApiResponse<string>> {
    return this.httpCommonService.post<ApiResponse<string>>
      ({ url: this.baseUrl + '/GenerateAgreement', body: dto });
  }

  downloadGeneratedAgreement(id: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.get<ApiResponse<string>>
      ({ url: this.baseUrl + '/DownloadGeneratedAgreement/' + id });
  }

  generateAgreementSignatureForm(agreementId: string): Observable<ApiResponse<string>> {
    return this.httpCommonService.get<ApiResponse<string>>
      ({ url: this.baseUrl + '/GenerateAgreementSignatureForm/' + agreementId });
  }
}
